export default __webpack_public_path__ + "static/media/map.ba8601cf.png";